let animation = (item, duration, distance, origin, scale = 1, interval = 0, delay = 0, opacity = 0 ) => {
    ScrollReveal().reveal(item, {
        duration: duration,  // Время анимации (Миллисекунды)
        distance: distance,  // Дистанция (Растояние в px - 40px)
        origin: origin, // Направление (Top, bottom, left, right)
        scale: scale, // Трансформация (От 1 до 0)
        interval: interval, // Интервал появления (Миллисекунды)
        delay: delay, // Задержка перед выполнением (Миллисекунды)
        opacity: opacity, // Прозрачность (От 1 до 0)
    });
}

// animation('.logo', 900, '40px', 'top', 0.85); Пример использования
 animation('.an-item-bottom', 900, '40px', 'bottom', 1);
 animation('.project-list .project-item', 900, '40px', 'bottom', 1);
 animation('.contact-item', 900, '40px', 'bottom', 1);
 animation('.contact-social', 900, '40px', 'bottom', 1);
 animation('.an-item-right', 900, '40px', 'right', 1);
 animation('.footer-back-form', 900, '40px', 'top', 0.85);

 animation('.an-about-left', 900, '100px', 'left',);
 animation('.an-about-right', 900, '100px', 'right',);

 $(window).scroll(function() {
    if($(window).scrollTop() > 0) {
        $('.header').addClass('header-scroll');
    } else {
        $('.header').removeClass('header-scroll');
    }
}); 